import axiosClient from './axiosClient';

export type BidDecisionType = 'GO' | 'NO_GO' | 'GO_WITH_CONDITIONS';

export interface BidDecisionData {
  id?: string;
  opportunityId?: string;
  decision: BidDecisionType;
  rationale: string;
  winThemes?: string;
  strategyNotes?: string;
  decidedById?: string;
  decidedBy?: string;
  approvedById?: string;
  approvedBy?: string;
  decidedAt?: string;
}

export const qualificationApi = {
  getBidDecision: async (opportunityId: string): Promise<BidDecisionData | null> => {
    try {
      const response = await axiosClient.get(`/opportunities/${opportunityId}/qualification/bid-decision`);
      return response.data;
    } catch (error: any) {
      if (error.response?.status === 204 || error.response?.status === 404) {
        return null;
      }
      throw error;
    }
  },

  submitBidDecision: async (opportunityId: string, data: { decision: BidDecisionType; rationale: string; winThemes?: string; strategyNotes?: string }): Promise<BidDecisionData> => {
    const response = await axiosClient.post(`/opportunities/${opportunityId}/qualification/bid-decision`, data);
    return response.data;
  },

  approveBidDecision: async (opportunityId: string): Promise<BidDecisionData> => {
    const response = await axiosClient.post(`/opportunities/${opportunityId}/qualification/bid-decision/approve`);
    return response.data;
  },
};
